require('./bootstrap');

//Load Vue
window.Vue = require('vue');

//Register Vue components
//TO DO: Add automatic component registration 
/*
Vue.component('audio-player', require('./components/AudioPlayer.vue').default);
Vue.component('example-component', require('./components/ExampleComponent.vue').default);
*/

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

import Vuex from 'vuex'
Vue.use(Vuex)

//import VueSlideoutPanel from 'vue2-slideout-panel';
//Vue.use(VueSlideoutPanel);
//Vue.component('slideout-panel', require('./components/SlideoutPanel.vue').default);

import store from "./store/store"


//Mount Vue at <div id="app"></div> in app.blade.php
var app = document.getElementById('app');
if (app) {
    const app = new Vue({
        el: '#app',
        store: store
    });
}

// TO DO: Only load popcorn.js for lesson page
//if (window.location.pathname === '/') {
    //require('./popcorn.js')
    //require('./popcorn.footnote.js')
    //require('./popcorn.applyclass.js')
    require('./freqtimeupdate.js')
    //require('./slideout.js')
//}
